<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <c-form>
                    <!-- <c-form-item type="input" label="会员名" name="login_name"></c-form-item> -->
                    <c-form-item type="input" label="会员昵称" name="nick_name"></c-form-item>
                    <c-form-item type="input" label="会员手机号" name="user_manage_mobilephone"></c-form-item>
                    <c-form-item type="input" label="邀请人手机" name="share_user_manage_mobilephone"></c-form-item>
                    <c-form-item type="select" label="会员等级" name="user_level" options="MEMBER_LEVEL_CLASSIFY"></c-form-item>
                    <c-form-item type="checkbox" label="用户状态" name="state" :options="stateType"></c-form-item>
                </c-form>
            </m-search>
			
          <m-operate v-show="higherLevel.platform_user_id">
            <c-button color="black" hollow @click="backHigher">返回</c-button>
            <span v-if="higherLevel.platform_user_id" style="margin-left: 10px; font-size: 13px;">上级：{{`${higherLevel.login_name}(${higherLevel.user_manage_mobilephone})`}}</span>
          </m-operate>
            <c-table ref="table" code="member_user_list">
                <c-table-column  label="会员昵称" name="nick_name" width="200">
                  <template v-slot="{data}">
                    <div class="flex-center-cross">
                      <c-image :src="data.head_photo" preview size="30" style="margin-right: 10px;"></c-image>
                      <span>{{data.nick_name}}</span>
                    </div>
                  </template>
                </c-table-column>

                <c-table-column  label="会员手机号" name="user_manage_mobilephone"  width="120">
                  <template v-slot="{data}">
                    <a v-if="data.user_level != 88 && data.team_count > 0" class="s-link" @click="loadLower(data)"> ↓ {{data.user_manage_mobilephone}}</a>
                    <span v-else>{{data.user_manage_mobilephone}}</span>
                  </template>
                </c-table-column>

                <c-table-column label="邀请人手机"  name="share_user_manage_mobilephone" width="120">
                </c-table-column>

                <c-table-column label="邀请人昵称" name="share_user_nick_name" width="120">
                </c-table-column>


                <c-table-column label="会员等级"  name="user_level_name" width="90">
                </c-table-column>

                <c-table-column  label="团队会员" name="team_count" width="80">
                <template v-slot="{data}">
                  <a v-if="data.user_level != 88 && data.team_count > 0" class="s-link" @click="loadLower(data)">{{data.team_count}}</a>
                  <span v-else>{{data.team_count}}</span>
                </template>
                </c-table-column>

                <c-table-column  label="直推会员" name="direct_count" width="70">
                </c-table-column>

                <c-table-column label="间推会员" name="indirect_count" width="70">
                </c-table-column>

                <c-table-column label="状态" name="state" width="80">
                    <template v-slot="{data}">
                      <span v-if="data.state == 1" style="color:green">启用</span>
                      <span v-if="data.state == 2" style="color:red">禁用</span>
                    </template>
                </c-table-column>

               <c-table-column  label="推荐账户" name="account" width="80">
                <template v-slot="{data}">
                    {{data.account}}
                </template>
               </c-table-column>

                <c-table-column label="佣金账户"  name="reward">
                  <template v-slot="{data}">{{data.reward}}</template>
                </c-table-column>

                <c-table-column  type="button" fixed="right" label="操作"  width="240">
                    <template v-slot="{data}">
                        <c-table-button power="b_member_user_view" @click="detail(data)" v-if="data.platform_user_id > 0">详情</c-table-button>
                        <c-table-button power="b_member_user_state" v-if="data.state == 2 && data.platform_user_id > 0" @click="updateState(1,data)">启用</c-table-button>
                        <c-table-button power="b_member_user_state" v-if="data.state == 1 && data.platform_user_id > 0" @click="updateState(2,data)">禁用</c-table-button>
                        <c-table-button power="b_member_user_view_zt" @click="viewRecommend('direct',data)">直推会员</c-table-button>
                        <c-table-button power="b_member_user_view_jt" @click="viewRecommend('indirect',data)">间推会员</c-table-button>
                        <c-table-button power="b_member_user_view_symx" @click="viewReward(data)">收益明细</c-table-button>
                        <c-table-button power="b_member_user_change" v-if="data.platform_user_id > 0" @click="setMember(data)">会员调整</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
        </module>

        <c-dialog ref="recommendDialog" title="直推会员" width="900" :button="false"  >
            <m-search ref="recommendsearch" @search="recommendSearchHandle">
                <c-form ref="form" inline>
                    <!-- <c-form-item type="input" label="会员名" name="login_name"></c-form-item> -->
                    <c-form-item type="input" label="手机号" name="user_manage_mobilephone"></c-form-item>
                    <c-form-item type="input" label="昵称" name="nick_name"></c-form-item>
                    <c-form-item type="select" label="会员等级" name="user_level" options="MEMBER_LEVEL_CLASSIFY"></c-form-item>
                </c-form>
            </m-search>
            <c-table ref="recommendTable" height="400">
                <c-table-column  label="昵称"  name="nick_name" width="200">
                  <template v-slot="{data}">
                    <div class="flex-center-cross">
                      <c-image :src="data.head_photo" preview size="30" style="margin-right: 10px;"></c-image>
                      <span>{{data.nick_name}}</span>
                    </div>
                  </template>
				        </c-table-column>

                <c-table-column label="手机号" name="user_manage_mobilephone" width="120"></c-table-column>

                <c-table-column label="会员等级" name="user_level_name" width="90">
                </c-table-column>

                <c-table-column label="状态" name="state"  width="80">
                    <template v-slot="{data}">
                      <span v-if="data.state == 1" style="color:green">启用</span>
                      <span v-if="data.state == 2" style="color:red">禁用</span>
                    </template>
                </c-table-column>
				
                <c-table-column  label="推荐账户"  name="account" width="90">
                  <template v-slot="{data}">
                      {{data.account}}
                  </template>
                </c-table-column>

                <c-table-column  label="佣金账户" name="reward" width="90">
                  <template v-slot="{data}">
                      {{data.reward}}
                  </template>
                </c-table-column>
            </c-table>
        </c-dialog>

        <c-dialog ref="indirectRecommendDialog" title="间推会员" width="1000" :button="false"  >
            <m-search ref="indirectRecommendsearch" @search="indirectRecommendSearchHandle">
                <c-form ref="form" inline>
                    <!-- <c-form-item type="input" label="会员名" name="login_name"></c-form-item> -->
                    <c-form-item type="input" label="手机号" name="user_manage_mobilephone"></c-form-item>
                    <c-form-item type="input" label="昵称" name="nick_name"></c-form-item>
                    <c-form-item type="select" label="会员等级" name="user_level" options="MEMBER_LEVEL_CLASSIFY"></c-form-item>
                </c-form>
            </m-search>
            <c-table ref="indirectRecommendTable" height="400">
              <c-table-column label="昵称" name="nick_name" width="200">
                <template v-slot="{data}">
                  <div class="flex-center-cross">
                    <c-image :src="data.head_photo" preview size="30" style="margin-right: 10px;"></c-image>
                    <span>{{data.nick_name}}</span>
                  </div>
                </template>
                </c-table-column>
                <c-table-column label="手机号" name="user_manage_mobilephone" width="120"
                ></c-table-column>

                <c-table-column label="邀请人手机" name="share_user_manage_mobilephone"  width="120">
                </c-table-column>

                <c-table-column  label="邀请人昵称" name="share_user_nick_name" width="120">
                </c-table-column>

                <c-table-column label="会员等级" name="user_level_name" width="90">
                </c-table-column>

                <c-table-column  label="状态" name="state" width="80">
                    <template v-slot="{data}">
                        {{data.state == 1 ? '启用' : '禁用'}}
                    </template>
                </c-table-column>
                <c-table-column label="推荐账户" name="account"  width="90">
                  <template v-slot="{data}">
                      {{data.account}}
                  </template>
                </c-table-column>
                <c-table-column label="佣金账户" name="reward" width="90">
                  <template v-slot="{data}">
                      {{data.reward}}
                  </template>
                </c-table-column>
            </c-table>
        </c-dialog>

        <c-dialog ref="rewardDialog" title="收益明细" width="1000" :button="false"  >
            <m-search ref="rewardSearch" @search="rewardSearchHandle">
                <c-form ref="form" inline>
                    <c-form-item type="checkbox" label="奖励类型" name="reward_type" :options="rewardType" ></c-form-item>
                    <c-form-item type="checkbox" label="奖励状态" name="state" :options="rewardState" ></c-form-item>
					          <c-form-item type="checkbox" label="" name="back_flag" :options="[{	name: '返现奖励',	value: 1},{	name: '普通奖励',	value: 0}]" ></c-form-item>
                    <c-form-item type="datetime" label="创建时间" start-name="start_date" end-name="end_date"></c-form-item>
                </c-form>
            </m-search>
            <c-table ref="rewardTable" height="400" >

                <c-table-column label="奖励类型" width="126"  name="reward_type">
                <template v-slot="{data}">
                    <span v-if="data.reward_type==1">分销差价</span>
                  <span v-if="data.reward_type==2">直推奖励<span v-if="data.back_money_level!=0">（返现）</span></span>
                  <span v-if="data.reward_type==3">间推奖励</span>
                  <span v-if="data.reward_type==4">团队奖励({{data.group_bl*100}}%)</span>
                </template>
                </c-table-column>
                <c-table-column  label="奖励金额" name="record_money" width="80" >
                  <template v-slot="{data}">
                      {{data.record_money}}
                  </template>
                </c-table-column>

                <c-table-column label="奖励状态"  name="state"  width="75" >
                    <template v-slot="{data}">
                        <span v-if="data.state==0"><span style="color:#aaaaaa">{{rewardStateMap[data.state]}}</span></span>
                        <span v-if="data.state==1"><span style="color:#888888">{{rewardStateMap[data.state]}}</span></span>
                        <span v-if="data.state==2"><span style="color:darkgreen">{{rewardStateMap[data.state]}}</span></span>
                    </template>
                </c-table-column>

                <c-table-column  label="关联用户" name="nick_name" width="200" >
                  <template v-slot="{data}">
                      {{data.nick_name}}【{{data.user_manage_mobilephone}}】
                  </template>
                </c-table-column>
                <c-table-column  label="推荐等级"  name="level_name" width="75" >
                  <template v-slot="{data}">
                      <span v-if="data.reward_type != 1">{{data.level_name}}</span>
                    <span v-else>--</span>
                  </template>
				      </c-table-column>
				    <c-table-column label="订单号"  name="relate_number"  width="120"></c-table-column>
            <c-table-column label="商品原价" name="original_product_money" width="80">
              <template v-slot="{data}">
                  <span v-if="data.reward_type == 1">{{data.original_product_money}}</span>
                <span v-else>--</span>
              </template>
            </c-table-column>
            <c-table-column label="商品成交价"  name="product_money" width="90">
              <template v-slot="{data}">
                  <span v-if="data.reward_type == 1 || data.reward_type == 4">{{data.product_money}}</span>
                <span v-else>--</span>
              </template>
            </c-table-column>
            <c-table-column  label="奖励时间" name="create_date" width="145"></c-table-column>
            <c-table-column label="到账时间"  name="settlement_date"  width="145"></c-table-column>
            </c-table>
        </c-dialog>

        <c-dialog ref="memberDialog" title="会员调整" width="600" @resolve="setMemberHandle">
            <c-form ref="memberForm">
				<c-form title="邀请人调整" title-margin="10">
					<c-form-item type="text" label="当前邀请人:" name="share_user_name"></c-form-item>
					<c-form-item type="hidden" name="share_user_id"></c-form-item>
					<c-form-item type="input" @click="$refs.memberUserSelector.open()" readonly label="修改为:" name="tran_share_user_name" required word="调整后该用户后续带来的奖励奖归于新的邀请人下"></c-form-item>
				</c-form>
				<c-form title="等级调整" title-margin="10">
					<c-form-item type="text" label="当前等级:" name="user_level_name"></c-form-item>
					<c-form-item type="select" label="调整为:" name="user_level" options="MEMBER_LEVEL_CLASSIFY" required></c-form-item>
				</c-form>
            </c-form>
        </c-dialog>

        <member-user-selector ref="memberUserSelector" @resolve="selectHandle($event, 'memberList', 'platform_user_id')"></member-user-selector>
    </page>
</template>

<script>
    import memberUserSelector from '@/components/service/member_user_selector.vue'
    export default {
        name: 'm_member_user',

        components: {
            memberUserSelector
        },

        data() {
            return {
                rewardState: [{
                    name: '取消奖励',
                    value: 0
                },{
                    name: '待到账',
                    value: 1
                },{
                    name: '已到账',
                    value: 2
                }
                ],
                rewardStateMap: {'0':'取消奖励','1':'待到账','2':'已到账'},
                rewardType: [{
                    name: '分销差价',
                    value: 1
                },{
                    name: '直推奖励',
                    value: 2
                },{
                    name: '间推奖励',
                    value: 3
                },{
                    name: '推荐团队奖励',
                    value: 4
                }
                ],
                stateType:[
                    {
                        name:'启用',
                        value:1
                    },{
                        name:'禁用',
                        value:2
                    }
                ],
                authenticationStateType:[
                  {
                      name:'未实名认证',
                      value:0
                  },{
                      name:'已实名认证',
                      value:1
                  }
                ],
                levelList: [],
                member_user_id: '',
                recommend_type: ''
              }
          },
		
		computed: {
			higherLevel() {
				return this.levelList[this.levelList.length - 1] || {};
			}
		},
		
		watch: {
			higherLevel(val) {
				this.$refs.search.clear();
				this.searchHandle();
			}
		},

        mounted() {
            this.$refs.search.search();
        },

        methods: {
            selectHandle(list, ref, key) {
                this.$refs.memberForm.set({
					tran_share_user_name: (list[0].nick_name||"") + "【"+ list[0].user_manage_mobilephone+"】",
					share_user_id: list[0].platform_user_id,
                });
            },

            setMemberHandle(stop) {

                stop();
                this.$refs.memberForm.submit({
                    url: '/member_user/adjustment',

                    rule: {
                        share_user_id: '请设置邀请人',
                        user_level: '请设置等级',
                    },

                    dataFormatter: data => {
                        data.member_user_id = this._edit.platform_user_id;
						delete data.tran_share_user_name;
                        return data;
                    },

                    success: data => {
                        this.$refs.table.update();
                        this.$refs.memberDialog.close();
                        this.$message({
                            text: '请求发送成功，调整结果可能稍有延迟!'
                        });
                    }
                })
            },

            setMember(data){
				console.log(data);
                this.$refs.memberForm.clear();
                this._edit = data;
                this.$refs.memberForm.set({
                    share_user_name:(data.share_user_nick_name||"") + "【" + data.share_user_manage_mobilephone +"】",
					tran_share_user_name: (data.share_user_nick_name||"") + "【" + data.share_user_manage_mobilephone +"】",
                    user_level_name:data.user_level_name,
					share_user_id:data.share_user_id,
					user_level:data.user_level
                });
                this.$refs.memberDialog.open();
            },


            viewRecommend(type,val){
                if(type == 'direct'){
                    this.$refs.recommendDialog.open();
                    this.recommend_type = type;
                    this.member_user_id = val.platform_user_id;
                    this.$refs.recommendTable.load({
                        url: '/member_user/recommend/list',
                        data: {
                            member_user_id: val.platform_user_id,
                            recommend_type: type
                        }
                    });
                }else{
                    this.$refs.indirectRecommendDialog.open();
                    this.recommend_type = type;
                    this.member_user_id = val.platform_user_id;
                    this.$refs.indirectRecommendTable.load({
                        url: '/member_user/recommend/list',
                        data: {
                            member_user_id: val.platform_user_id,
                            recommend_type: type
                        }
                    });
                }


            },

            viewReward(val){
                this.$refs.rewardDialog.open();
                this.member_user_id = val.platform_user_id;
                this.$refs.rewardTable.load({
                    url: '/member_user/reward/list',
                    data: {
                        member_user_id: val.platform_user_id,
                    }
                });
            },

            recommendSearchHandle(data) {
                data.member_user_id = this.member_user_id;
                data.recommend_type = this.recommend_type;
                this.$refs.recommendTable.load({
                    url: '/member_user/recommend/list',
                    data
                });
            },

            indirectRecommendSearchHandle(data) {
                data.member_user_id = this.member_user_id;
                data.recommend_type = this.recommend_type;
                this.$refs.indirectRecommendTable.load({
                    url: '/member_user/recommend/list',
                    data
                });
            },

            rewardSearchHandle(data) {
                data.member_user_id = this.member_user_id;
                this.$refs.rewardTable.load({
                    url: '/member_user/reward/list',
                    data
                });
            },

            searchHandle(data = {}) {
				data.member_user_id = this.higherLevel.platform_user_id;
                this.$refs.table.load({
                    url: '/member_user/list',
                    data
                });
            },

            detail(val) {
                this.navigateTo({
                    path: '/member/'+val.platform_user_id,
                });
            },

            updateState(type,val) {
                this.$confirm({
                    text: '确定要'+(type==1?'启用':'禁用')+'【'+val.user_manage_mobilephone+'】吗？',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: '/platform_user/update_state',
                            data: {platform_user_id:val.platform_user_id,state:type},
                            loading: true,
                            success: data => {
                                this.$message({
                                    text: '操作成功',
                                    icon: 'success'
                                });
                                this.$refs.table.update();
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            },
			
			loadLower(data) {
				this.levelList.push(data);
			},
			
			backHigher() {
				this.levelList.splice(this.levelList.length - 1, 1);
			}
        }
    }
</script>